import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { ApiBaseService } from './api-base.service';
import { PaymentGatewayModel } from '@models/PaymentGatewayModel';
import { SharedService } from './shared.service';
import { Country } from '@shared/models/Enums';


// Configuración de cobro por país (pasarela, moneda y costo del servicio).
// La pasarela la decide el servidor y puede cambiar sin desplegar el cliente,
// así que acá nunca se asume cuál le toca a cada país: se pregunta y se obedece.
// Por lo mismo la respuesta no se persiste, solo se cachea en memoria y se
// descarta al cambiar de país.
@Injectable()
export class ApiPaymentGatewayService extends ApiBaseService {

    private config: PaymentGatewayModel = null;
    private configCountry: Country = null;

    // Evita que dos componentes del mismo checkout disparen la llamada a la vez
    private pending: Promise<PaymentGatewayModel> = null;
    private pendingCountry: Country = null;

    constructor(public http: HttpClient, public sharedService: SharedService) {
        super(http, sharedService);
    }

    // Payment Gateway API //


    // Config del país ya cargada, o null si todavía no se pidió.
    get current(): PaymentGatewayModel {

        return this.config;
    }

    // GET: api/admin/meta/payment-gateway/reads/v1/{country}
    /**
     * Devuelve la pasarela, la moneda y el costo del servicio del país. Anónimo:
     * se consulta antes de mostrar el formulario de pago y la compra sin registro
     * no tiene token.
     * @param {Country} country - País del cobro.
     * @param {boolean} forceRefresh - true al entrar al flujo de pago, para no
     * arrastrar una configuración que el servidor ya cambió.
     * @returns una Promesa que retorna la configuración de cobro (PaymentGatewayModel).
     * Rechaza con 404 si el país no está habilitado.
     */
    getPaymentGateway(country: Country, forceRefresh = false): Promise<PaymentGatewayModel> {

        // Cambió el país: lo que había en memoria ya no aplica
        if (this.configCountry != country) this.clear();

        if (!forceRefresh && this.config != null) {

            return Promise.resolve(this.config);
        }

        if (this.pending != null && this.pendingCountry == country) {

            return this.pending;
        }

        this.pendingCountry = country;
        this.pending = this.http.get(`${this.baseUrl}/api/admin/meta/payment-gateway/reads/v1/${country}`, this.getHttpOptionsWithoutSession(country))
            .toPromise().then(
                (result: any) => {

                    const paymentGateway = new PaymentGatewayModel(result);
                    paymentGateway.country = country;

                    this.config = paymentGateway;
                    this.configCountry = country;
                    this.pending = null;

                    return paymentGateway;
                },
                (err: HttpErrorResponse) => {

                    this.clear();

                    const errMsg = this.getErrorMsg(err);

                    return Promise.reject(new Error(`Error al cargar la configuración de cobro: ${errMsg}`));
                }
            );

        return this.pending;
    }

    clear(): void {

        this.config = null;
        this.configCountry = null;
        this.pending = null;
        this.pendingCountry = null;
    }
}
